import { render, staticRenderFns } from "./NewsCardMenu.vue?vue&type=template&id=2431700f&scoped=true"
import script from "./NewsCardMenu.vue?vue&type=script&lang=js"
export * from "./NewsCardMenu.vue?vue&type=script&lang=js"
import style0 from "./NewsCardMenu.vue?vue&type=style&index=0&id=2431700f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2431700f",
  null
  
)

export default component.exports